module.exports = __webpack_public_path__ + "static/media/Tanjeela.33d8e4d8.jpg";